<template>
  <div class="echarts-contain">
    <template>
      <div :id="id" class="o-echarts"></div>
      <!-- <div class="currentYear" v-if="$attrs.showYear">{{new Date().getFullYear()}}年</div> -->
    </template>
  </div>
</template>

<script>
import echarts from "echarts";

export default {
  name: "lineCharts",
  props: {
    data: Array,
    color: String, // 如果是green则绿色模式，否则是白色模式
    unit: String // 单位
  },
  data() {
    return {
      id: "echarts_" + new Date().getTime() + Math.floor(Math.random() * 1000),
      echartObj: null,
      unitName: "条"
    };
  },
  mounted() {
    this.unitName = this.unit ? this.unit : "条";
    this.option = {
      title: {
        text: new Date().getFullYear() + "年",
        bottom: '5%',
        left: "45%",
        textStyle: {
          color: "#999999",
          fontSize: 12,
          fontWeight: 'normal'
        }
      },
      tooltip: {
        trigger: "axis",
        position: function(point, params, dom) {
          return [point[0], "40%"];
        },
        confine: true,
        // alwaysShowContent: false, /** tooltip 弹出层是否展示 */
        extraCssText:
          "background: #333;opacity: .9;min-width: 53px;height: 44px;font-size: 12px;line-height: 16px;color:#fff;padding: 0;border-radius: 0;text-align:left;padding: 6px 6px 0;",
        formatter: params => {
          return params[0].axisValue + "日" + "<br />" + params[0].value + "人";
        }
      },
      xAxis: {
        splitNumber: 100
      },
      dataZoom: [
        {
          type: "inside",
          start: 0,
          end: 60,
          zoomLock: true
        }
      ],
      grid: {
        top: 50,
        right: 24,
        left: 60
      },

      yAxis: {
        name: ` 单位 (${this.unitName})`,
        nameGap: "16",
        splitNumber: 6,
        nameTextStyle: {
          color: "#999"
        },
        type: "value",
        axisLine: {
          // y轴
          show: false
        },
        // 网格样式
        splitLine: {
          show: true,
          lineStyle: {
            color: "#E9E9E9",
            width: 0.5,
            type: "solid"
          }
        },
        axisTick: {
          // y轴刻度线
          show: false
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: "#999"
          },
          formatter: value => {
            if (value.toString().length < 5) {
              return value;
            } else if (value.toString().length < 9) {
              return value / 10000 + "(万)";
            } else if (value.toString().length < 13) {
              return value / 100000000 + "(亿)";
            }
          }
        }
      },
      lineStyle: {
        color: "rgba(54,179,116,0)",
        width: 1
      },
      itemStyle: {
        normal: {
          color: "#36B374"
        },
        // color: "rgba(54,179,116,1)",
        borderColor: "#36B374",
        opacity: 1
      },
      series: [
        {
          name: "预约人数",
          type: "line"
        }
      ]
    };
    this.echartObj = echarts.init(document.getElementById(this.id));
    this.echartObj.setOption(this.setSeriesData(), true);
  },
  watch: {
    data: {
      handler(newValue, oldValue) {
        for (let i = 0; i < newValue.length; i++) {
          if (oldValue[i] !== newValue[i]) {
            this.echartObj.setOption(this.setSeriesData(), true);
          }
        }
      },
      deep: true
    }
  },
  methods: {
    // 尝试返回数据后刷新试图
    freshCharts() {
      this.echartObj.setOption(this.setSeriesData(), true);
    },
    getXaxisData() {
      // 填入横轴数据
      if (this.data.length > 0) {
        return this.data.map(item => {
          return item.xAxis.toString().replace("-", "月");
        });
      }
    },
    getSeriesData() {
      // 填入数据
      if (this.data.length > 0) {
        return this.data.map(item => {
          return item.num;
        });
      }
    },
    setSeriesData() {
      this.setOptions(
        "xAxis",
        (() => {
          return {
            type: "category",
            boundaryGap: false,
            splitNumber: 1000,
            minInterval: 100,
            data: this.getXaxisData(),
            axisLine: {
              show: true,
              lineStyle: {
                color: "#E9E9E9"
              }
            },
            axisTick: {
              // y轴刻度线
              show: true
            },
            axisLabel: {
              interval: 0,
              show: true,
              textStyle: {
                color: "#999999"
              }
            }
          };
        })()
      );
      this.setOptions(
        "legend",
        (() => {
          return {
            bottom: -4,
            symbol: "none",
            textStyle: {
              color: "#999",
              fontSize: 10
            }
          };
        })()
      );
      this.setOptions(
        "series",
        (() => {
          return {
            name: "预约人数",
            data: this.getSeriesData(),
            type: "line",
            lineStyle: {
              width: 1,
              color: "rgba(54,179,116,1)"
            },
            // smooth: true,
            symbol: "emptyCircle", // 拐点设置为实心
            symbolSize: 6, // 拐点大小
            itemStyle: {
              normal: {
                color: "#36B374", // 图例圆圈的颜色
                borderWidth: 1, // 拐点边框大小
                label: {
                  // show: true,
                  color: "#fff"
                  // this.color === "green"
                  //   ? "rgba(54,179,116,1)"
                  //   : "rgba(255,255,255,1)",
                  // formatter: function(param) {
                  //   return param.value == "0" ? "" : param.value;
                  // }
                }
              },
              emphasis: {
                color: "#fff" // hover拐点颜色定义
              }
            }
          };
        })()
      );
      return this.option;
    },
    setOptions(objKey, objVal) {
      if (
        this.option[objKey] &&
        typeof this.option[objKey] === "object" &&
        !Array.isArray(this.option[objKey])
      ) {
        this.option[objKey] = Object.assign(this.option[objKey], objVal);
      } else {
        this.option[objKey] = objVal;
      }
      this.$set(this.option, objKey, this.option[objKey]);
    }
  }
};
</script>

<style lang="less" scoped>
.echarts-contain {
  width: 100%;
  height: 100%;
  position: relative;
  .o-echarts {
    width: 100%;
    height: 99%;
    padding-bottom: 10px;
  }
  .o-echarts:nth-child(1) {
    z-index: 99 !important;
  }
  .currentYear {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 19px;
    padding-bottom: 14px;
    color: #999999;
    font-size: 12px;
  }
}
</style>
